export const MIN_START_DELAY = 0;
export const MAX_START_DELAY = 900;
